export default __webpack_public_path__ + "static/media/08.b0c30db0.png";